import { UserInfoType } from 'pages/Auth/auth.types';

export const LOCAL_STORAGE_USER_NODE: string = 'flipme-user';
export const LOCAL_STORAGE_USER_SIGNIN_NODE: string = 'flipme-user-signIn';
export const LOCAL_STORAGE_USER_REGISTER_NODE: string = 'flipme-user-register';
export const LOCAL_STORAGE_TOKEN: string = 'flipme-token';
export const LOCAL_STORAGE_CART: string = 'flipme-cart';

export const store = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export const read = (key: string) => {
  return localStorage.getItem(key) as string;
};

export const getTokens = () => {
  return JSON.parse(read(LOCAL_STORAGE_TOKEN));
};

export const getAccessToken = () => {
  return JSON.parse(read(LOCAL_STORAGE_TOKEN))?.accessToken;
};

export const getRefreshToken = () => {
  return JSON.parse(read(LOCAL_STORAGE_TOKEN))?.refreshToken;
};

export const setNewAccessToken = (accessToken: string) => {
  let tokens = JSON.parse(read(LOCAL_STORAGE_TOKEN));
  tokens.accessToken = accessToken;
  store(LOCAL_STORAGE_TOKEN, JSON.stringify(tokens));
};

export const setTokensToLS = (tokens: any) => {
  store(LOCAL_STORAGE_TOKEN, JSON.stringify(tokens));
};

export const setUserToLS = (userData: any) => {
  store(LOCAL_STORAGE_USER_NODE, JSON.stringify(userData));
};

export const getUserFromLS = () => {
  return JSON.parse(read(LOCAL_STORAGE_USER_NODE));
};

export const removeUserFromLS = () => {
  localStorage.removeItem(LOCAL_STORAGE_USER_NODE);
  localStorage.removeItem(LOCAL_STORAGE_USER_REGISTER_NODE);
  localStorage.removeItem(LOCAL_STORAGE_USER_SIGNIN_NODE);
  localStorage.removeItem(LOCAL_STORAGE_TOKEN);
};

//REGISTER

export const setUserRegisterToLS = (register: any) => {
  store(LOCAL_STORAGE_USER_REGISTER_NODE, JSON.stringify(register));
};

export const getUserRegisterFromLS = () => {
  return JSON.parse(read(LOCAL_STORAGE_USER_REGISTER_NODE));
};

//SIGNIN

export const setSignInUserToLS = (userData: any) => {
  store(LOCAL_STORAGE_USER_SIGNIN_NODE, JSON.stringify(userData));
};

//CART
export const addToCartLS = (item: any) => {
  store(LOCAL_STORAGE_CART, JSON.stringify(item));
};

export const getCartFromLS = () => {
  return JSON.parse(read(LOCAL_STORAGE_CART));
};

export const removeCartFromLS = () => {
  localStorage.removeItem(LOCAL_STORAGE_CART);
};
